// Great-circle distance and display formatting shared by the geocode preview and the on-scene confirm.

const EARTH_RADIUS_M = 6_371_000;

export function haversineMeters(lat1: number, lng1: number, lat2: number, lng2: number): number {
    const phi1 = (lat1 * Math.PI) / 180;
    const phi2 = (lat2 * Math.PI) / 180;
    const dPhi = ((lat2 - lat1) * Math.PI) / 180;
    const dLambda = ((lng2 - lng1) * Math.PI) / 180;
    const a = Math.sin(dPhi / 2) ** 2 + Math.cos(phi1) * Math.cos(phi2) * Math.sin(dLambda / 2) ** 2;
    return 2 * EARTH_RADIUS_M * Math.asin(Math.sqrt(a));
}

/** Imperial (ft / mi) for country 'US'; metric everywhere else, including when no country is known. */
export function formatDistance(meters: number, country?: string): string {
    if (country === 'US') {
        const miles = meters / 1609.344;
        if (miles < 1) {
            const feet = Math.round(meters * 3.28084);
            return `${feet.toLocaleString()} ft`;
        }
        return `${miles.toFixed(1)} mi`;
    }
    if (meters < 1000) {
        return `${Math.round(meters)} m`;
    }
    return `${(meters / 1000).toFixed(1)} km`;
}
